import React from 'react';
import messages from './translations';
import Router from './Router';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from './icons';
import AppProvider from '@afosto/app-components-react/AppProvider';
import SessionManager from '@afosto/auth/SessionManager';

SessionManager.client = {
  id: process.env.REACT_APP_QUICQ_CLIENT_ID,
  scopes: ['iam:subscriptions:read', 'qcq:proxies:read', 'qcq:proxies:write', 'iam:usage:read'],
};

library.add(icons);

const App = () => (
  <AppProvider app="qcq" messages={messages}>
    <Router />
  </AppProvider>
);

export default App;
